import { useState, useLayoutEffect } from "react";

function getScroll(container, direction = "vertical") {
  let scrollPos = 0;
  if (container) {
    return direction === "vertical"
      ? container.scrollTop
      : container.scrollLeft;
  } else {
    if (document.documentElement && document.documentElement !== null) {
      scrollPos =
        direction === "vertical"
          ? document.documentElement.scrollTop
          : document.documentElement.scrollLeft;
    }
    return direction === "vertical"
      ? window.pageYOffset || scrollPos
      : window.pageXOffset || scrollPos;
  }
}

export default function useScrollThreshold(
  threshold = 0,
  container,
  direction = "vertical"
) {
  const [passed, setPassed] = useState(
    getScroll(container, direction) >= threshold
  );

  useLayoutEffect(() => {
    const handleScroll = () =>
      setPassed(getScroll(container, direction) >= threshold);
    (container || window).addEventListener("scroll", handleScroll);
    return () =>
      (container || window).removeEventListener("scroll", handleScroll);
  }, [container, direction, threshold]);

  return passed;
}
